var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var client = require('../client.js');
var currentScopes = require('../currentScopes.js');
var debugBuild = require('../debug-build.js');
var spanOnScope = require('../utils/spanOnScope.js');
var is = require('../utils-hoist/is.js');
var logger = require('../utils-hoist/logger.js');
var time = require('../utils-hoist/time.js');
var worldwide = require('../utils-hoist/worldwide.js');
var constants = require('./constants.js');
var envelope = require('./envelope.js');
var MAX_LOG_BUFFER_SIZE = 100;

// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
worldwide.GLOBAL_OBJ._sentryClientToLogBufferMap = new WeakMap();

/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */
function logAttributeToSerializedLogAttribute(value) {
  switch (typeof value) {
    case 'number':
      if (Number.isInteger(value)) {
        return {
          value: value,
          type: 'integer'
        };
      }
      return {
        value: value,
        type: 'double'
      };
    case 'boolean':
      return {
        value: value,
        type: 'boolean'
      };
    case 'string':
      return {
        value: value,
        type: 'string'
      };
    default:
      {
        var stringValue = '';
        try {
          var _JSON$stringify;
          stringValue = (_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
        } catch (_unused) {
          // Do nothing
        }
        return {
          value: stringValue,
          type: 'string'
        };
      }
  }
}

/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */
function _INTERNAL_captureLog(beforeLog) {
  var _client$1$getSdkMetad;
  var client$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : currentScopes.getClient();
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : currentScopes.getCurrentScope();
  if (!client$1) {
    debugBuild.DEBUG_BUILD && logger.logger.warn('No client available to capture log.');
    return;
  }
  var _client$1$getOptions = client$1.getOptions(),
    _experiments = _client$1$getOptions._experiments,
    release = _client$1$getOptions.release,
    environment = _client$1$getOptions.environment;
  var _ref = _experiments !== null && _experiments !== void 0 ? _experiments : {},
    _ref$enableLogs = _ref.enableLogs,
    enableLogs = _ref$enableLogs === void 0 ? false : _ref$enableLogs,
    beforeSendLog = _ref.beforeSendLog;
  if (!enableLogs) {
    debugBuild.DEBUG_BUILD && logger.logger.warn('logging option not enabled, log will not be captured.');
    return;
  }
  var _client$_getTraceInfo = client._getTraceInfoFromScope(client$1, scope),
    _client$_getTraceInfo2 = _slicedToArray(_client$_getTraceInfo, 2),
    traceContext = _client$_getTraceInfo2[1];
  var processedLogAttributes = _objectSpread({}, beforeLog.attributes);
  if (release) {
    processedLogAttributes['sentry.release'] = release;
  }
  if (environment) {
    processedLogAttributes['sentry.environment'] = environment;
  }
  var _ref2 = (_client$1$getSdkMetad = client$1.getSdkMetadata()) !== null && _client$1$getSdkMetad !== void 0 ? _client$1$getSdkMetad : {},
    sdk = _ref2.sdk;
  if (sdk) {
    processedLogAttributes['sentry.sdk.name'] = sdk.name;
    processedLogAttributes['sentry.sdk.version'] = sdk.version;
  }
  var beforeLogMessage = beforeLog.message;
  if (is.isParameterizedString(beforeLogMessage)) {
    var __sentry_template_string__ = beforeLogMessage.__sentry_template_string__,
      _beforeLogMessage$__s = beforeLogMessage.__sentry_template_values__,
      __sentry_template_values__ = _beforeLogMessage$__s === void 0 ? [] : _beforeLogMessage$__s;
    processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
    __sentry_template_values__.forEach(function (param, index) {
      processedLogAttributes["sentry.message.parameter.".concat(index)] = param;
    });
  }
  var span = spanOnScope._getSpanForScope(scope);
  if (span) {
    // Add the parent span ID to the log attributes for trace context
    processedLogAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
  }
  var processedLog = _objectSpread(_objectSpread({}, beforeLog), {}, {
    attributes: processedLogAttributes
  });
  client$1.emit('beforeCaptureLog', processedLog);
  var log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
  if (!log) {
    client$1.recordDroppedEvent('before_send', 'log_item', 1);
    debugBuild.DEBUG_BUILD && logger.logger.warn('beforeSendLog returned null, log will not be captured.');
    return;
  }
  var level = log.level,
    message = log.message,
    _log$attributes = log.attributes,
    attributes = _log$attributes === void 0 ? {} : _log$attributes,
    severityNumber = log.severityNumber;
  var serializedLog = {
    timestamp: time.timestampInSeconds(),
    level: level,
    body: message,
    trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
    severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : constants.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
    attributes: Object.keys(attributes).reduce(function (acc, key) {
      acc[key] = logAttributeToSerializedLogAttribute(attributes[key]);
      return acc;
    }, {})
  };
  var logBuffer = _INTERNAL_getLogBuffer(client$1);
  if (logBuffer === undefined) {
    var _worldwide$GLOBAL_OBJ;
    (_worldwide$GLOBAL_OBJ = worldwide.GLOBAL_OBJ._sentryClientToLogBufferMap) === null || _worldwide$GLOBAL_OBJ === void 0 || _worldwide$GLOBAL_OBJ.set(client$1, [serializedLog]);
  } else {
    var _worldwide$GLOBAL_OBJ2;
    (_worldwide$GLOBAL_OBJ2 = worldwide.GLOBAL_OBJ._sentryClientToLogBufferMap) === null || _worldwide$GLOBAL_OBJ2 === void 0 || _worldwide$GLOBAL_OBJ2.set(client$1, [].concat(_toConsumableArray(logBuffer), [serializedLog]));
    if (logBuffer.length >= MAX_LOG_BUFFER_SIZE) {
      _INTERNAL_flushLogsBuffer(client$1, logBuffer);
    }
  }
  client$1.emit('afterCaptureLog', log);
}

/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */
function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
  var _ref3, _worldwide$GLOBAL_OBJ3;
  var logBuffer = (_ref3 = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : _INTERNAL_getLogBuffer(client)) !== null && _ref3 !== void 0 ? _ref3 : [];
  if (logBuffer.length === 0) {
    return;
  }
  var clientOptions = client.getOptions();
  var envelope$1 = envelope.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());

  // Clear the log buffer after envelopes have been constructed.
  (_worldwide$GLOBAL_OBJ3 = worldwide.GLOBAL_OBJ._sentryClientToLogBufferMap) === null || _worldwide$GLOBAL_OBJ3 === void 0 || _worldwide$GLOBAL_OBJ3.set(client, []);
  client.emit('flushLogs');

  // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.sendEnvelope(envelope$1);
}

/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */
function _INTERNAL_getLogBuffer(client) {
  var _worldwide$GLOBAL_OBJ4;
  return (_worldwide$GLOBAL_OBJ4 = worldwide.GLOBAL_OBJ._sentryClientToLogBufferMap) === null || _worldwide$GLOBAL_OBJ4 === void 0 ? void 0 : _worldwide$GLOBAL_OBJ4.get(client);
}
exports._INTERNAL_captureLog = _INTERNAL_captureLog;
exports._INTERNAL_flushLogsBuffer = _INTERNAL_flushLogsBuffer;
exports._INTERNAL_getLogBuffer = _INTERNAL_getLogBuffer;
exports.logAttributeToSerializedLogAttribute = logAttributeToSerializedLogAttribute;